module.exports = __webpack_public_path__ + "3272da21a82a3d91092dfe4e1db2d207.png";